import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import useNetworkOauthUrls from '@/utils/hooks/signup/useNetworkOauthUrls';
import useUserFBPermissions from '@/utils/hooks/swr/useUserFBPermissions';
import useAcl from '@/utils/hooks/user/useAcl';
import useUserRole from '@/utils/hooks/user/useUserRole';

import { aclFeatures } from '@/lib/acl/aclFeatures';
import { PERMISSIONS } from '@/lib/permissions/socialPermissions';
import { FACEBOOK } from '@/lib/socialProfile';

import QuickActionsModal, { ModalAction } from '@/components/composite/Modals/QuickActionsModal';

export const UnlockDMPermissionPopin = () => {
    const { t } = useTranslation('conversations');
    const router = useRouter();
    const { user: userFBPermissions } = useUserFBPermissions();
    const { getOauthUrl } = useNetworkOauthUrls();
    const { isAdmin, isManager } = useUserRole();
    const { hasAcl } = useAcl();

    const canCreateDirectMessages = hasAcl(aclFeatures.direct_messages.base.create);
    const canReadDirectMessages = hasAcl(aclFeatures.direct_messages.base.read);
    const hasAccessToDirectMessages = canCreateDirectMessages || canReadDirectMessages;

    const unlockPermission = () => {
        window.location.assign(
            getOauthUrl({
                network: FACEBOOK,
                permissions: hasAccessToDirectMessages ? [PERMISSIONS.DIRECT_MESSAGES] : []
            })
        );
    };

    const backToComments = () => {
        router.push('/conversations/comments');
    };

    if (userFBPermissions?.permissions.includes(PERMISSIONS.DIRECT_MESSAGES)) {
        return null;
    }

    const canUnlockPermission = isAdmin || isManager;

    const actions: ModalAction[] = [
        {
            label: t('direct_messages.unlock_dm_permission_popin.grant_permission'),
            onClick: unlockPermission,
            icon: 'link',
            hidden: !canUnlockPermission,
            testId: 'grant-permission-button'
        },
        {
            label: t('direct_messages.unlock_dm_permission_popin.go_back'),
            className: !canUnlockPermission && 'w-[100%]',
            onClick: backToComments,
            testId: 'go-back-button'
        }
    ];

    return (
        <QuickActionsModal
            title={t('direct_messages.unlock_dm_permission_popin.title')}
            description={
                canUnlockPermission
                    ? t('direct_messages.unlock_dm_permission_popin.description')
                    : t('direct_messages.unlock_dm_permission_popin.description_no_rights')
            }
            actions={actions}
            isOpen={true}
            withCloseButton={false}
            size="lg"
            containerClassName="p-10"
            titleClassName="text-left"
            descriptionClassName="text-md text-left font-GMedium text-icoGray-500"
            footerClassName="flex w-full gap-3 p-0"
            testId="unlock-dm-permission-popin"
        />
    );
};
